import React, { useCallback, useState } from 'react';

import { ProductsTable } from '../styles';

import Item from '../Item';

function Category({
  type,
  category,
  n99FoodRestaurants,
}) {
  const items = type === 'complement' ? category.complements : category.products;

  return (
    <div style={{
      margin: 'auto',
      width: '95%',
      backgroundColor: '#fff',
      borderRadius: '7px',
      paddingBottom: '20px',
      marginTop: '30px',
      overflow: 'hidden',
      borderRadius: '8px',
      border: '1px solid #f4f4f4',
    }}>
      <div style={{
        height: '90px',
        display: 'flex',
        alignItems: 'center',
        paddingRight: '30px',
        paddingLeft: '30px',
        backgroundColor: '#f4f4f4',
        justifyContent: 'space-between',
      }}>
        {/* CategoryName */}
        <div style={{ fontWeight: 'bold' }}>
          <span style={{ fontSize: '22px' }}>{category.name}</span>
        </div>
      </div>

      <ProductsTable responsive borderless>
        <thead>
          <tr>
            <th>Item</th>
            <th>Preço</th>
            <th>99Food</th>
            <th />
          </tr>
        </thead>

        <tbody>
          {items &&
            items.map((item, index) => (
              <Item
                type={type}
                key={item.id}
                item={item}
                n99FoodRestaurants={n99FoodRestaurants}
              />
            ))}
        </tbody>
      </ProductsTable>
    </div>
  );
}

export default Category;
